import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(registrationVerifyEmailWithPassword);

    /** @ngInject */
    function registrationVerifyEmailWithPassword($stateProvider) {
        $stateProvider.state('verifyAccountWithPassword', {
            url: '/auth/registration/confirm-set/:token/',
            template:
                require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/auth/registration/verify_email_with_password/verify_email_with_password.html'),
            controller: 'RegistrationVerifyEmailWithPasswordController',
            controllerAs: 'RegistrationVerifyEmailWithPasswordCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/registration/verify_email_with_password/verify_email_with_password.route.ts